<itl-card
  [header]="'product.economicValue' | translate"
  *ngIf="economicValue"
  [ngClass]="
    {
      A: 'card__economic_value_a',
      B: 'card__economic_value_b',
      C: 'card__economic_value_c',
      X: 'card__economic_value_x'
    }[economicValue]
  "
>
  {{ economicValue }}
</itl-card>
